export default "__VITE_ASSET__B$n1Huv4__"